export default "__VITE_ASSET__BAAy9COb__"